import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

/**
 * Subtle icon-only toggle. Uses bg-transparent so it sits cleanly in any header.
 * Pass `className` to position/size it for the parent (e.g. fixed top-right).
 */
export default function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? "Bytt til lyst tema" : "Bytt til mørkt tema"}
      title={isDark ? "Bytt til lyst tema" : "Bytt til mørkt tema"}
      data-testid="theme-toggle"
      className={`inline-flex items-center justify-center w-9 h-9 rounded-lg text-foreground/70 hover:text-foreground hover:bg-accent active:scale-95 transition-all duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 ${className}`}
    >
      {isDark ? (
        <Sun className="w-4 h-4" strokeWidth={1.75} />
      ) : (
        <Moon className="w-4 h-4" strokeWidth={1.75} />
      )}
    </button>
  );
}
